module.exports = __webpack_public_path__ + "static/img/carousel_5_nx3ajx_ar_16_9_w_2400.f3ed9a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_2400.jpg
// module id = uS86
// module chunks = 0